import { useMemo } from "react";
import { convertToGalleryItemList } from "./../../_shared/media/convert-to-gallery-item-list";
function useItems(items, relValue, anchorTarget) {
  const galleryItems = useMemo(() => {
    return convertToGalleryItemList(items, relValue, anchorTarget);
  }, [items]);
  return galleryItems;
}
export {
  useItems
};
//# sourceMappingURL=useItems.js.map
